import React from 'react';
import {Tabs} from 'antd';
import UserAccount from "./UserAccount";
import PasswordActions from "./PasswordActions";
import NotificationActions from "./NotificationActions";
import UserActions from "./UserActions/index";

const Index = () => {

    return (
        <Tabs tabPosition="left">
            <Tabs.TabPane tab="Hesap İşlemleri" key="1">
                <UserAccount/>
            </Tabs.TabPane>
            <Tabs.TabPane tab="Bildirim İşlemleri" key="2">
                <NotificationActions/>
            </Tabs.TabPane>
            <Tabs.TabPane tab="Şifre İşlemleri" key="3">
                <PasswordActions/>
            </Tabs.TabPane>
            <Tabs.TabPane tab="Rol İşlemleri" key="4">
                <UserActions/>
            </Tabs.TabPane>
        </Tabs>
    );
};

export default Index;
